/** Коды валют для стоимости покупки и продажи. */
export const CURRENCIES = [
  { code: 'RUB', label: 'Рубль (RUB)' },
  { code: 'USD', label: 'Доллар (USD)' },
  { code: 'EUR', label: 'Евро (EUR)' },
  { code: 'CNY', label: 'Юань (CNY)' },
];

export const CURRENCY_LABELS = {
  RUB: 'RUB',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY',
};

/**
 * @param {number|null|undefined} amount
 * @param {string} [currency]
 * @returns {string}
 */
export function formatMoney(amount, currency = 'RUB') {
  if (amount == null || amount === '') return 'Не указана';
  const code = CURRENCY_LABELS[currency] || currency || 'RUB';
  return `${new Intl.NumberFormat('ru-RU').format(amount)} ${code}`;
}
